import { MerchantSubscription, MerchantSubscriptions, Subscription } from "src/resources/api/subscription/types.api";

export const FeatureTypes = {
  LANDING_PAGE: 'LANDING_PAGE',
  LANDING_PAGE_PUBLISH: 'LANDING_PAGE_PUBLISH',
  MERCHANT_THEME_SETTINGS: 'MERCHANT_THEME_SETTINGS',
  INTERACTIVE_TOOLS: 'INTERACTIVE_TOOLS',
  DISPLAY_CUSTOMER_EMAIL: 'DISPLAY_CUSTOMER_EMAIL',
  IMPACT_WIDGET: 'IMPACT_WIDGET',
  ONE_OFF_PURCHASE_WIDGET: 'ONE_OFF_PURCHASE_WIDGET',
  CARBONCLICK_TILE_DYNAMIC: 'CARBONCLICK_TILE_DYNAMIC',
  CARBONCLICK_TILE_STATIC: 'CARBONCLICK_TILE_STATIC',
  CREATE_SUBMERCHANT_FOR_LARGE_EVENTS: 'CREATE_SUBMERCHANT_FOR_LARGE_EVENTS',
  CREATE_SUBMERCHANT: 'CREATE_SUBMERCHANT',
  CREATE_PARTNER_MERCHANT: 'CREATE_PARTNER_MERCHANT',

  CARBONCLICK_API: 'CARBONCLICK_API',

  MANAGE_BUSINESS_CUSTOMER: 'MANAGE_BUSINESS_CUSTOMER',
  FOOTPRINT: 'FOOTPRINT',
  PROJECT_PURCHASE: 'PROJECT_PURCHASE',
  PORTFOLIO_PURCHASE: 'PORTFOLIO_PURCHASE',
  EMAIL_CUSTOMIZATION: 'EMAIL_CUSTOMIZATION',
  FOOTPRINT_BULK_INPUT: 'FOOTPRINT_BULK_INPUT',

  PURCHASE_BY_INVOICE: 'PURCHASE_BY_INVOICE',

  CREATE_MANAGED_PROGRAMME: 'CREATE_MANAGED_PROGRAMME'
} as const;

export interface Feature {
  code: keyof typeof FeatureTypes;
  valueNumeric?: number;
}

export interface SubscriptionsState {
  features: Feature[];
  isFeaturesLoading: boolean;
  currentPlan?: MerchantSubscription;
  subscriptions: MerchantSubscriptions;
  subscriptionsAreLoading: boolean;
  subscriptionPlans: Subscription[] | null;
  isPlansLoading: boolean;
  getPlanByPlanLevel: (packageCode: string) => Subscription | undefined;
  onSubscribeButtonClick: (planId: string, planLevel?: number) => void;
  onUpdateToAnnualButtonClick: (packageCode: string, currency: string, interval: string) => void;
  onCancelButtonClick: () => void;
  onUpdatePaymentMethod: () => Promise<void>;
  planCurrency: string;
  setPlanCurrency: (curr: string) => void;
  fetchSubscriptions?: (merchantCode: string) => Promise<void>; // TODO: delete
  isStripeSubscription: boolean;
  availablePlanCurrencies: string[];
  isLoadingCreateSub: boolean;
  isLoadingUpdateSub: boolean;
}

export enum PlanType {
  MONTHLY = 'month',
  ANNUAL = 'year',
}
